import { paramType } from "dataSource/lookup";
import { FileUploader, Form } from "devextreme-react";
import { Popup } from "devextreme-react/popup";
import notify from "devextreme/ui/notify";
import { formatUploadFileData } from "plugin/helper";
import httpRequest from "plugin/httprequest";
import React, { Component } from "react";

class ModalGlobalParam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      popupVisible: false,
      DataMaster: {},
      uploadedData: []
    };

    this.columns = [
      {
        dataField: 'paramCode',
        label: {
          text: "Global Param Code",
          alignment: "left",
        },
        editorOptions: {
          elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
          readOnly: true
        }
      },
      {
        dataField: 'paramName',
        label: {
          text: "Global Param Name",
          alignment: "left",
        },
        editorOptions: {
          elementAttr: { class: "bd-input-popup-disabled-dapen-default" },
          readOnly: true
        }
      },
      {
        dataField: 'paramType',
        label: {
          text: "Global Param Type",
          alignment: "left",
        },
        editorType: 'dxSelectBox',
        editorOptions: {
          elementAttr: { class: "bd-input-popup-dapen-default" },
          dataSource: paramType(),
          valueExpr: 'id',
          displayExpr: 'value',
          onValueChanged: async (e) => {
            this.setField(e.value)
          }
        },
      },
      {
        dataField: 'stringValue',
        label: {
          text: "Value"
        },
        editorOptions: {
          elementAttr: { class: "bd-input-popup-dapen-default" }
        },
        visible: false
      },
      {
        dataField: 'intValue',
        label: {
          text: "Value"
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: { class: "bd-input-popup-dapen-default" }
        },
        visible: false
      },
      {
        dataField: 'floatValue',
        label: {
          text: "Value"
        },
        editorType: 'dxNumberBox',
        editorOptions: {
          elementAttr: { class: "bd-input-popup-dapen-default" },
        },
        visible: false
      },
      {
        dataField: 'dateValue',
        label: {
          text: "Value"
        },
        editorType: 'dxDateBox',
        editorOptions: {
          elementAttr: { class: "bd-input-popup-dapen-default" },
          displayFormat: 'dd MMM yyyy'
        },
        visible: false
      },
    ];


    this.PopupToolbarItem = [

      {
        widget: "dxButton",
        location: "after",
        options: {
          text: "Batal",
          onClick: this.hide.bind(this)
        },
        toolbar: "bottom"
      },
      {
        widget: "dxButton",
        location: "after",
        options: {
          elementAttr: { class: "bg-button-popup-save-dapen-default" },
          text: "Simpan",
          onClick: this.updateData.bind(this)
        },
        toolbar: "bottom"
      },
    ];

    this.formRef = React.createRef()
    this.fileUploderRef = React.createRef()
    this.isByteValue = false
  }

  onUploadStarted = (e) => {
    var fieldName = e.component._options._optionManager._options.name
    this.fieldName = fieldName
    for (var i = 0; i < e.value.length; i++) {
      var files = e.value[i];

      var fr = new FileReader();

      var formattedFileData;

      var DataMaster = { ...this.state.DataMaster };

      fr.onload = efr => {
        formattedFileData = formatUploadFileData(efr.target.result);

        // DataMaster[`${fieldName}Name`] = files.name;
        DataMaster[`${fieldName}Value`] = formattedFileData.base64data;
        DataMaster[`${fieldName}ValueContentType`] = formattedFileData.mime;
        this.setState({
          DataMaster: DataMaster
        });
      };

      fr.readAsDataURL(files);
    }
  }

  retriveDataGlobalParam = async (data) => {
    var paramType = data.paramType
    if (paramType == 'B') this.isByteValue = true

    this.setField(paramType)

    this.setState({
      DataMaster: data,
    })
  }

  setField = (paramType) => {
    this.formRef.current.instance.beginUpdate();

    const options = {
      'S': { stringValue: true, intValue: false, floatValue: false, dateValue: false, visible: false },
      'I': { stringValue: false, intValue: true, floatValue: false, dateValue: false, visible: false },
      'F': { stringValue: false, intValue: false, floatValue: true, dateValue: false, visible: false },
      'D': { stringValue: false, intValue: false, floatValue: false, dateValue: true, visible: false },
      'B': { stringValue: false, intValue: false, floatValue: false, dateValue: false, visible: true }
    };

    const selectedOption = options[paramType];

    if (selectedOption) {
      Object.entries(selectedOption).forEach(([key, value]) => {
        this.formRef.current.instance.itemOption(key, 'visible', value);
      });

      this.fileUploderRef.current.instance.option('visible', selectedOption.visible);

      if (paramType === 'B') {
        this.isByteValue = true;
      }
    }
    this.formRef.current.instance.endUpdate();
  }

  updateData = async () => {
    let type = "success";
    let text = "Global param has been update successfully!";
    let loadAPI = `global-parameters`

    var response = await httpRequest(
      process.env.REACT_APP_BACKEND,
      this.props.store,
      loadAPI,
      "PUT",
      {
        values: this.state.DataMaster,
        key: this.state.DataMaster
      }, this.state.DataMaster
    );

    if (response) {
      notify(
        {
          message: text,
          width: "AUTO",
          shading: true,
          position: { at: "center", my: "center", of: window }
        },
        type,
        600
      );


    } else {
      notify(
        {
          message: "Error",
          width: "AUTO",
          shading: true,
          position: { at: "center", my: "center", of: window }
        },
        "error",
        600
      );
    }

    this.props.forceRefresh()
    this.hide()
  }

  show = () => {
    this.setState({
      popupVisible: true
    });
  };

  hide = () => {

    this.isByteValue = false
    this.setState({
      popupVisible: false,

      DataMaster: {},
      uploadedData: []
    });

    this.formRef.current.instance.itemOption('stringValue', 'visible', false)
    this.formRef.current.instance.itemOption('intValue', 'visible', false)
    this.formRef.current.instance.itemOption('floatValue', 'visible', false)
    this.formRef.current.instance.itemOption('dateValue', 'visible', false)
    this.fileUploderRef.current.instance.option('visible', false)
  };


  render() {
    return (
      <React.Fragment>
        <Popup
          className={"popup"}
          visible={this.state.popupVisible}
          onHiding={this.hide}
          dragEnabled={false}
          showTitle={true}
          title={"Global Param"}
          width={"50vw"}
          height={"auto"}
          toolbarItems={this.PopupToolbarItem}
        >
          <Form
            colCount={2}
            id={"formMaster"}
            formData={this.state.DataMaster}
            items={this.columns}
            ref={this.formRef}
          />
          <FileUploader
            accept={".png,.jpg,.jpeg,.gif,.bmp,application/pdf"}
            uploadMode={"useForm"}
            onValueChanged={this.onUploadStarted.bind(this)}
            labelText="Upload File"
            showFileList={false}
            name={"byte"}
            value={this.state.uploadedData}
            ref={this.fileUploderRef}
          />
          <div className={`row ${this.isByteValue ? '' : 'd-none'}`}>
            <label className="col-2">File:</label>
            <img src={`data:image/png;base64, ${this.state.DataMaster.byteValue || ''}`} width={"200px"} height={"100px"} alt="logo" />

          </div>
        </Popup>
      </React.Fragment>

    );
  }
}

export default ModalGlobalParam;
